// 简体中文 (zh-CN)

export const zhCN = {
  brand: {
    name: 'DoneLine',
    tagline: '专为个人打造的项目管理工具',
  },
  common: {
    save: '保存',
    cancel: '取消',
    confirm: '确认',
    delete: '删除',
    rename: '重命名',
    archive: '归档',
    add: '添加',
    close: '关闭',
    edit: '编辑',
    new: '新建',
    yes: '是',
    no: '否',
    back: '返回',
    next: '下一步',
    skip: '跳过',
    done: '完成',
    loading: '加载中…',
    sending: '发送中…',
    saving: '保存中…',
    untitled: '未命名',
    today: '今天',
    tomorrow: '明天',
    yesterday: '昨天',
    none: '无',
    optional: '可选',
    requiredField: '必填',
    confirmDelete: '确认删除？',
  },
  nav: {
    today: '今日',
    upcoming: '未来',
    inbox: '收件箱',
    projects: '我的项目',
    tags: '标签',
    reports: '周报',
    settings: '设置',
    quickCapture: '快速捕获',
    search: '搜索',
    newProject: '新建项目',
    addSection: '添加分组',
    menu: '菜单',
    openMenu: '打开菜单',
  },
  search: {
    title: '搜索',
    placeholder: '搜索任务、项目、标签…',
    noResults: '没有结果',
    tasks: '任务',
    projects: '项目',
    tags: '标签',
  },
  today: {
    title: '今日',
    eyebrow: '今日',
    overdue: '逾期',
    today: '今日',
    completed: '已完成',
    empty: '今天没有安排，放松一下 ☕',
    summary: '{active} 进行 · {done} 完成',
    reschedule: '重新安排',
    rescheduled: '已重新安排 {count} 个任务',
  },
  inbox: {
    title: '收件箱',
    eyebrow: '收件箱',
    empty: '收件箱是空的。',
    pending: '{count} 待处理',
  },
  upcoming: {
    title: '未来',
    eyebrow: '未来 7 天',
    todayLabel: '今天',
    tomorrowLabel: '明天',
    empty: '未来 7 天没有任务。',
  },
  project: {
    eyebrow: '项目',
    notFound: '项目不存在',
    notFoundHint: '它可能已被删除或归档。',
    inProgress: '{count} 进行中',
    completed: '{count} 完成',
    ungrouped: '未分组',
    addSection: '添加分组',
    listView: '列表',
    ganttView: '甘特图',
    ganttZoomIn: '放大',
    ganttZoomOut: '缩小',
    ganttWide: '宽屏',
    ganttCompact: '恢复正常宽度',
    empty: '项目还没有任务',
    emptyHint: '使用上方输入框开始添加。',
    sectionEmpty: '— 暂无任务 —',
    completedSection: '已完成',
    newSectionTitle: '新建分组',
    newSectionPlaceholder: '分组名称',
    renameProjectTitle: '重命名项目',
    renameProjectPlaceholder: '项目名称',
    editProjectTitle: '编辑项目',
    color: '颜色',
    icon: '图标',
    noIcon: '无图标',
    deleteProjectTitle: '删除项目「{name}」？',
    deleteProjectDesc: '该项目下的任务会移到收件箱。此操作不可撤销。',
    archiveProject: '归档',
    actionsMenu: '项目操作',
    renameSectionTitle: '重命名分组',
    sectionDeleteTitle: '删除分组「{name}」？',
    sectionDeleteDesc: '该分组下的任务会移回项目根目录，此操作无法撤销。',
    sectionActionsMenu: '分组操作',
    sectionReorder: '调整分组顺序',
    descriptionPlaceholder: '为这个项目写点什么…',
    descriptionEditHint: '支持 Markdown · ⌘↵ 保存 · Esc 关闭',
    descriptionEmpty: '点击添加项目笔记',
  },
  reports: {
    eyebrow: '周报',
    title: '过去 7 天回顾',
    serverGeneratedAt: '服务器生成于 {time}',
    syncingFromServer: '从服务器同步中…',
    computedLocally: '本地计算',
    aiSummary: 'AI 周报摘要',
    completedCount: '完成数',
    completionRate: '完成率',
    overdueCount: '逾期数',
    dailyAverage: '日均',
    dailyCompleted: '每日完成数',
    dailyCompletedAxis: '（任务数）',
    byProject: '按项目分布',
    noCompletedThisWeek: '本周还没有完成任务。',
    serverNotReady: '服务器还没生成这周周报。每周一 09:00（按你的时区）batch worker 会自动产出。',
  },
  upgrade: {
    title: '升级到 DoneLine Pro',
    featureLocked: '「{feature}」是 Pro 功能。',
    comingSoon: 'Pro 即将开放，到时你的账号会自动就绪。',
    signInFirst: '登录后开通',
    benefits: {
      unlimitedProjects: '无限项目（免费版上限 3 个）',
      history: '365 天修改历史（免费版仅 7 天）',
      gantt: '甘特图视图',
      importExport: '导入 / 导出数据',
      themes: '更多主题，包含 Paper',
    },
    feature: {
      projects: '3 个以上项目',
      gantt: '甘特图',
      importExport: '导入 / 导出',
      paperTheme: 'Pro 主题',
    },
    cta: {
      stripe: '订阅 — 月付 $2.99 / 年付 $29.99',
      apple: '通过 Apple 订阅',
      google: '通过 Google Play 订阅',
    },
  },
  plan: {
    title: '套餐',
    description: '你的订阅级别。',
    free: '免费',
    pro: 'Pro',
    proAi: 'Pro AI',
    upgradeButton: '升级到 Pro',
    devSwitchHint: '开发预览：临时切换套餐以查看不同限额',
    switchToFree: '切到免费（预览）',
    switchToPro: '切到 Pro（预览）',
  },
  settings: {
    display: {
      title: '显示',
      description: '选择任务一览行内展示哪些信息。',
      tags: '标签',
      tagsHint: '在任务行显示标签',
      descriptionLabel: '描述',
      descriptionHint: '显示一行描述预览',
      subtasks: '子任务',
      subtasksHint: '显示子任务进度与展开箭头',
    },
    eyebrow: '设置',
    title: '偏好与外观',
    appearance: {
      title: '外观',
      description: '选择最适合当前情境的主题。',
    },
    language: {
      title: '语言',
      description: '应用界面文字的显示语言。',
    },
    desktop: {
      title: '桌面端',
      description: '原生 macOS / Windows / Linux 行为。仅在桌面应用里生效。',
      alwaysOnTopLabel: '窗口置顶',
      alwaysOnTopHint: '把窗口固定在所有应用之上，再次切换关闭。',
      globalHotkeyLabel: '全局快速捕捉快捷键',
      globalHotkeyHint: '系统级 ⌘⇧Space — 在任意 app 唤起 DoneLine 并聚焦捕捉框。',
    },
    account: {
      title: '账户',
      description: '登录信息与统计概览。',
      summary: '共 {tasks} 个任务 · {projects} 个项目',
      signOut: '退出登录',
      deleteAccount: '删除账号',
      deleteAccountConfirmTitle: '删除账号？',
      deleteAccountConfirmBody:
        '将永久删除你的账号，以及服务器和此浏览器中的全部任务、项目和标签。此操作不可撤销。想保留数据请先导出。',
      deleteAccountConfirm: '删除',
      deleteAccountFailed: '删除账号失败',
      signingOut: '退出中…',
      notSignedIn: '未登录',
      signInCta: '登录',
      guestHint: '游客模式：数据仅存本机。登录后开启同步与云端备份。',
      displayNameLabel: '显示名称',
      displayNamePlaceholder: '你的名字',
      displayNameSaved: '已保存',
      displayNameSaveFailed: '保存失败',
      avatarLabel: '头像',
      avatarHint: '支持 JPG / PNG / WEBP / GIF，最大 2 MB。未上传时显示首字母。',
      avatarUpload: '上传图片',
      avatarChange: '更换图片',
      avatarUploading: '上传中…',
      avatarRemove: '移除',
      avatarSaved: '头像已更新',
      avatarSaveFailed: '更新头像失败',
      avatarErrorType: '不支持的图片格式。请使用 JPG / PNG / WEBP / GIF。',
      avatarErrorSize: '图片过大，最大 2 MB。',
    },
    sync: {
      title: '同步',
      description: '与服务器对齐一次完整的增量拉取。',
      forceSync: '立即强制同步',
      syncing: '同步中…',
      done: '同步完成',
    },
    shortcuts: {
      title: '快捷键',
      description: '键盘是最快的指针。',
      view: '查看快捷键',
    },
    data: {
      title: '数据',
      description: '所有数据先存在本地，再同步到服务器。',
      export: '导出 JSON',
      import: '导入 JSON',
      exportDone: '已导出 {n} 条任务',
      importDone: '已导入 {n} 条新数据',
      importError: '导入失败：{error}',
      importPersistFailed: '导入未能写入本地存储：数据可能超出设备存储限额，请分批导入。',
      clearAll: '清空本地数据',
      clearConfirmTitle: '清空所有本地数据？',
      clearConfirmDesc:
        '这会删除浏览器内存储的所有内容；服务器上已同步的数据不会受影响。完成后页面会重新加载。',
      cleared: '已清空，重新加载…',
    },
    about: {
      title: '关于',
      version: '版本 {v}',
      description: '基于 GTD 理念的个人 todo 和项目管理工具。',
    },
  },
  guest: {
    banner: '游客模式 — 数据仅保存在本机。登录后可多端同步。',
    bannerCta: '登录',
    emptyHint: '登录前，数据仅保存在本机。先在下方添加第一个任务吧。',
    storageWarning:
      '游客数据仅存于此浏览器，可能被系统清理。请及时登录或导出备份（导出文件未加密）。',
  },
  login: {
    welcomeBack: '欢迎回来',
    helperSupabase: '输入邮箱，给你发送一次性登录链接。',
    helperLocal: '本地体验模式：输入邮箱即可登录，数据仅保存在本设备。',
    emailPlaceholder: 'you@example.com',
    sendLink: '发送登录链接',
    sendingLink: '发送中…',
    sentSupabase: '已发送到 {email}，请到邮箱中点击登录链接。',
    otpPrompt: '或输入邮件里的验证码',
    otpPlaceholder: '6 位验证码',
    otpSubmit: '登录',
    otpFailed: '验证码无效或已过期',
    sentLocal: '已登录 {email}，正在进入…',
    modeSupabase: 'Supabase Auth',
    modeLocal: '本地体验模式',
    skipGuest: '跳过，先直接使用',
    skipFailed: '无法进入游客模式（本地存储写入失败），请重试。',
    merge: {
      title: '本机已有 {count} 个任务',
      keep: '合并到我的账号',
      irreversible: '登录后将上传到账号，合并后无法撤销。',
      discard: '不保留本地数据，直接登录',
      discardConfirmTitle: '登录后将删除本机 {count} 个任务',
      discardConfirmBody: '登录完成后，本机的 {count} 个任务将被永久删除，无法恢复。确定继续？',
    },
    error: '登录失败',
  },
  task: {
    recurringAdvanced: '重复任务已推进到 {date}',
    recurringFinished: '重复已结束，任务已完成',
    titlePlaceholder: '任务标题',
    description: '描述',
    descriptionPlaceholder: '添加描述…',
    descriptionEmpty: '暂无描述。',
    descriptionEdit: '编辑描述',
    descriptionSave: '保存描述',
    descriptionCancel: '取消',
    save: '保存',
    saved: '已保存',
    discardConfirmTitle: '丢弃未保存的修改？',
    discardConfirmDesc: '你有未保存的编辑。关闭将丢失这些改动。',
    priority: '优先级',
    date: '日期',
    project: '项目',
    section: '分组',
    parentTask: '父任务',
    tags: '标签',
    subtasks: '子任务',
    expandSubtasks: '展开子任务',
    collapseSubtasks: '折叠子任务',
    addSubtaskPlaceholder: '+ 添加子任务',
    comments: '评论',
    noComments: '暂无评论',
    commentPlaceholder: '写一条评论…',
    sendComment: '发送',
    delete: '删除',
    deleteConfirmTitle: '删除这个任务？',
    deleteConfirmDesc: '它的子任务也会一并删除。',
    saveHint: '⌘/Ctrl + Enter 保存并关闭',
    open: '打开',
    completed: '已完成',
    markComplete: '标记为完成',
    markIncomplete: '标记为未完成',
    moreActions: '更多操作',
  },
  priority: {
    high: '高',
    mid: '中',
    low: '低',
    none: '无',
    p1: 'P1',
    p2: 'P2',
    p3: 'P3',
    p4: 'P4',
  },
  date: {
    picker: {
      single: '单日',
      datetime: '时点',
      range: '区间',
      today: '今天',
      tomorrow: '明天',
      thisWeekend: '本周末',
      nextWeek: '下周',
      noDate: '无日期',
    },
    overdue: '逾期',
    notScheduled: '未设置日期',
  },
  recurrence: {
    title: '重复',
    none: '不重复',
    custom: '自定义…',
    applyCustom: '应用自定义规则',
    end: '结束重复',
    preset: {
      daily: '每天',
      weekdays: '工作日',
      weekly: '每周',
      biweekly: '每 2 周',
      monthly: '每月',
      yearly: '每年',
    },
    summary: {
      daily: '每天',
      everyNDays: '每 {n} 天',
      weekly: '每周',
      everyNWeeks: '每 {n} 周',
      weeklyOn: '每周{days}',
      everyNWeeksOn: '每 {n} 周 · {days}',
      monthly: '每月',
      everyNMonths: '每 {n} 个月',
      yearly: '每年',
      everyNYears: '每 {n} 年',
    },
    weekday: { sun: '日', mon: '一', tue: '二', wed: '三', thu: '四', fri: '五', sat: '六' },
    freq: { daily: '天', weekly: '周', monthly: '月', yearly: '年' },
    every: '每',
  },
  aiUsage: {
    title: 'AI 用量',
    planFree: '免费档',
    planPro: 'Pro 档',
    planProAi: 'Pro AI 档',
    usedOf: '本月 {used} / {limit} 次',
    remaining: '剩余 {count} 次',
    resetsMonthly: '每月 1 日（UTC）重置',
    history: '最近使用',
    historyEmpty: '还没有使用记录',
    endpointParse: 'AI 解析',
    endpointBreakdown: 'AI 拆解',
    signInFirst: '登录后可查看 AI 用量',
    loadFailed: '加载失败',
    retry: '重试',
  },
  parseTask: {
    mode: 'AI',
    quickMode: '快速',
    title: 'AI 任务解析',
    placeholder: '用一句话描述任务…',
    titlePlaceholder: '任务标题',
    hint: 'AI 自动填好日期、优先级、项目和标签',
    parse: '解析',
    confirm: '添加任务',
    confirmMany: '添加 {count} 个任务',
    back: '返回',
    voice: '语音输入',
    voiceDenied: '麦克风权限被拒绝',
    voiceUnavailable: '当前浏览器不支持语音输入',
    errors: {
      rateLimited: '请求过于频繁，请稍后再试',
      monthlyLimit: '本月 AI 次数已用完，升级可获得更多',
      unauthorized: '请先登录后再使用 AI',
      unavailable: 'AI 暂时不可用',
      failed: '无法解析任务，请换种说法',
    },
  },
  quickCapture: {
    placeholder: '添加任务…（Enter 保存）',
    hint: '试试：「买菜 tomorrow @生活/采购 #快速 p2」',
    newTag: '#{name}（新建）',
    dismissMatch: '将“{label}”保留为文字',
    createTag: '创建标签“{name}”',
    syntaxCheatsheet: 'today / tomorrow / next mon · @项目[/分区] · #标签 · p1-p4',
    add: '添加',
    open: '打开快速捕获',
    addTask: '添加任务',
  },
  tag: {
    eyebrow: '标签',
    editTagTitle: '编辑标签',
    renameTagPlaceholder: '标签名',
    newTagPlaceholder: '新标签…',
    deleteTagTitle: '删除标签「{name}」？',
    deleteTagDesc: '将从 {count} 个任务上移除该标签，此操作不可撤销。',
    actionsMenu: '标签操作',
    nameTaken: '已有同名标签',
    empty: '没有带此标签的任务',
  },
  quickbar: {
    signInRequired: '请先登录',
    signInHint: '登录后才能从状态栏添加任务。',
    signInOpenMain: '请打开 DoneLine 主窗口完成登录',
  },
  sync: {
    idle: '已同步',
    syncing: '同步中',
    offline: '离线',
    error: '同步失败',
    disabled: '本地模式',
    pending: '{count} 待上传',
    syncingPending: '同步中 · {count} 待上传',
    offlinePending: '离线 · {count} 待上传',
    authError: '认证失败 — 请重新登录',
    rejectedBatch: '数据验证失败 — 部分更改已丢弃',
    retry: '点击重试',
  },
  commandPalette: {
    placeholder: '搜索任务、跳转视图、执行命令…',
    empty: '没有匹配项。',
    tasks: '任务',
    projects: '项目',
    navigation: '导航',
    actions: '操作',
  },
  bulk: {
    toolbar: '批量操作',
    selected: '已选 {count} 项',
    clear: '取消选择',
    deleteTitle: '删除选中的 {count} 个任务？',
    deleteDesc: '其子任务也会一并删除。此操作无法撤销。',
    mixedProjects: '多个项目',
  },
  shortcuts: {
    title: '快捷键',
    quickAdd: '快速捕获',
    search: '搜索',
    help: '显示此面板',
    gotoToday: '跳到今日',
    gotoInbox: '跳到收件箱',
    gotoUpcoming: '跳到未来',
    drawer: {
      title: '任务详情中',
      saveClose: '保存并关闭',
      delete: '删除任务',
      priorityKeys: '设置优先级（1=高 … 4=无）',
    },
  },
  welcome: {
    title: '欢迎使用 {brand}',
    subtitle: '30 秒带你上手。',
    step1: {
      title: '一秒钟捕获任何想法',
      body: '任意页面按 Q 键打开快速捕获。输入任务名按 Enter，直接进入收件箱。',
    },
    step2: {
      title: '有空再整理',
      body: '把任务拖到项目和分组里。日期、优先级、标签都可以稍后再补。',
    },
    step3: {
      title: '规划每一天',
      body: '今日视图自动汇总今天到期、以及覆盖今天的日期区间内的所有任务。',
    },
    step4: {
      title: '准备就绪',
      body: '我们准备了几个引导任务帮你熟悉操作，完成或删除随你。',
    },
    getStarted: '开始使用',
  },
  onboarding: {
    project: {
      welcome: '欢迎',
      learn: '了解',
    },
    tasks: {
      welcome: '👋 欢迎使用 {brand}！',
      welcomeDesc: '点击左侧的复选框把这条标记为完成 —— 这就是完成任务的方式。',
      quickAdd: '⚡ 试试快速捕获：按 Q 键，或左上角的快速捕获按钮',
      quickAddDesc:
        '输入任务名按 Enter 即可。可以用 @项目名 归到项目、#标签名 打标签、p1-p4 设优先级。',
      organize: '📁 用项目把相关任务组织起来',
      organizeDesc: '点击左侧栏「+ 新建项目」创建。把任务拖进去整理。',
      schedule: '🗓 设个日期来安排时间',
      scheduleDesc: '设了今天的任务会自动出现在「今日」视图。试试打开这条任务并设个截止日期。',
      priority: '🔥 用优先级（P1 高 … P4 无）',
      priorityDesc: '在任务详情里按 1 / 2 / 3 / 4 快速切换优先级。',
      drag: '✋ 拖动重新排序',
      dragDesc: '把鼠标移到任务上，左侧会出现拖动手柄，按住可以拖到新位置。',
      gantt: '📊 用甘特图看时间线',
      ganttDesc: '打开任意项目，切到「甘特图」标签，看任务在时间轴上的分布。',
      reports: '📈 用周报回顾',
      reportsDesc: '每周看你完成了什么、哪些被推迟了。',
      finishMe: '✅ 把这个清单完成 —— 你已经准备好了！',
    },
  },
  errors: {
    networkError: '网络错误',
    unknownError: '未知错误',
    notFound: '未找到',
    pageNotFound: '页面未找到',
    pageNotFoundDesc: '这个地址不存在，或者已被移动。',
    backHome: '回到今日',
    somethingWrong: '出了点问题',
    tryAgain: '重试',
    goHome: '回到首页',
  },
  theme: {
    light: '浅色',
    dark: '深色',
    paper: '纸张',
    rose: '玫瑰',
    lavender: '薰衣草',
    peach: '蜜桃',
    mauve: '暗玫',
    slate: '石板',
    forest: '森林',
    midnight: '午夜',
    shiba: '柴犬',
    cat: '猫咪',
    ocean: '海洋',
    sky: '天空',
    mint: '薄荷',
    matcha: '抹茶',
    amber: '琥珀',
    mocha: '摩卡',
    crimson: '绯红',
    nord: '北欧',
    dracula: '德古拉',
    graphite: '石墨',
    system: '系统',
    pickerTitle: '主题',
  },
} as const;
